import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './ContactUs.css'
import SendConfirmation from './SendConfirmation';
import MoreImagesCard from '../../components/MoreImagesCard';
import { useTranslation } from 'react-i18next';
import useLanguagePrefix from '../../LanguagePrefix';


function ContactUs() {
    const { t } = useTranslation();
    const [isSent, setIsSent] = useState(false);
    const [isFormat, setIsFormat] = useState(true);
    const [formData, setFormData] = useState({
        fullName: "",
        role: "Owner/Founder",
        phoneNumber: "",
        email: "",
        message: ""
    });

    const [issending, setIsSending] = useState(false);
    const langPrefix = useLanguagePrefix();

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "phoneNumber") {
            let cleanedValue = value.replace(/[^\d+]/g, "");

            if (cleanedValue.includes("+")) {
                cleanedValue = "+" + cleanedValue.replace(/\+/g, "").replace(/^\+/, "");
            }

            setFormData({ ...formData, [name]: cleanedValue });
            return;
        }

        setFormData({ ...formData, [name]: value });
    };

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isFormat) {
            try {
                const response = await fetch("https://api.prostay.com/Website/contact-us", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData)
                });
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }

                setIsSent(true);
                setFormData({ fullName: "", role: "", email: "", phoneNumber: "", message: "" });
            }
            catch (error) {
                console.error("Error sending request:", error);
            }
        }
    };

    const isDisabledButton = formData.fullName.trim() === "" || formData.role.trim() === ""
        || formData.email.trim() === "" || !isValidEmail(formData.email);

    return (
        <div>
            <Helmet>
                <title>Prostay – Contact the Team | Sales & Support </title>
                <meta name="description" content="Need help or want to talk with sales? Get in touch with the Prostay team—we’re here to support your journey." />
                <link rel="canonical" href={"https://www.prostay.com" + langPrefix + "/contact-us/"} />

                <link rel="alternate" href="https://www.prostay.com/en/contact-us/" />
                <link rel="alternate" href="https://www.prostay.com/es/contact-us/" />

                <meta property="og:title" content="Prostay – Contact the Team | Sales & Support" />
                <meta property="og:description" content="Need help or want to talk with sales? Get in touch with the Prostay team—we’re here to support your journey." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={"https://www.prostay.com" + langPrefix + "/contact-us/"}  />
                <meta property="og:image" content='https://prostay.com/images/ogImage.png' />

                <meta property="og:site_name" content="Prostay" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Prostay – Contact the Team | Sales & Support" />
                <meta name="twitter:description" content="Need help or want to talk with sales? Get in touch with the Prostay team—we’re here to support your journey." />
                <meta name="twitter:image" content='https://prostay.com/images/ogImage.png' />
                <meta name="twitter:site" content="@prostaypms" />
                <meta name="twitter:creator" content="@prostaypms" />


            </Helmet>
            <div className='contact-us'>
                <div className='background-image'>
                    <div className='background-image-start'>
                        <div className='mt-2 d-flex align-items-center gap-1 chip'>
                            {t('Get in touch')}
                        </div>
                        <div className='mt-2' style={{ maxWidth: '550px' }}>
                            <h1>
                                {t('Contact Us')}
                            </h1>
                            <p className='mt-4 bigger-text body-large'>
                                {t('Reach out to us anytime and we’ll make sure your message gets to the right person. We typically respond within 6 hours every day.')}
                            </p>
                        </div>
                    </div>
                </div>
                {isSent && isFormat ? (
                    <SendConfirmation />
                ) : (
                    <div className='padding-inline-phone'>
                        <div className='form-container'>
                            {
                                issending ?
                                    <>
                                        <div className="d-flex align-items-center justify-content-center" style={{ height: '477px ' }}>
                                            <div className="spinner-container">
                                                <div className="custom-spinner"></div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <h4 style={{ maxWidth: '340px' }}>{t('We’re Here When You Need Us')}</h4>
                                        <form onSubmit={handleSubmit} className="form-submit mt-4">
                                            <div className="group-input">
                                                <div className='d-flex flex-column width-second-row gap-1'>
                                                    <small>{t('Full Name*')}</small>
                                                    <input
                                                        type="text"
                                                        name="fullName"
                                                        value={formData.fullName}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className='d-flex flex-column width-second-row gap-1'>
                                                    <small>{t('Role*')}</small>
                                                    <select style={{ appearance: 'none' }} name="role" value={formData.role} onChange={handleChange}>
                                                        <option value="Owner/Founder">{t('Owner/Founder')}</option>
                                                        <option value="General Manager">{t('General Manager')}</option>
                                                        <option value="Operations Manager">{t('Operations Manager')}</option>
                                                        <option value="Sales & Marketing">{t('Sales & Marketing')}</option>
                                                        <option value="IT Department">{t('IT Department')}</option>
                                                        <option value="Revenue Management">{t('Revenue Management')}</option>
                                                        <option value="Consultant">{t('Consultant')}</option>
                                                        <option value="Other">{t('Other')}</option>
                                                    </select>
                                                    <svg className='svg-arrow' width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6 9.5L12 15.5L18 9.5" stroke="#808698" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <div className="group-input">
                                                <div className='d-flex flex-column width-second-row gap-1'>
                                                    <small>{t('E-Mail*')}</small>
                                                    <input
                                                        type="text"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className='d-flex flex-column width-second-row gap-1'>
                                                    <small>{t('Phone Number')}</small>
                                                    <input
                                                        type="text"
                                                        name="phoneNumber"
                                                        value={formData.phoneNumber}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className='d-flex flex-column gap-1'>
                                                <small>{t('Message (Optional)')}</small>
                                                <textarea style={{ height: '153px' }}
                                                    name="message"
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    placeholder={t('Send us your message')}
                                                ></textarea>
                                            </div>
                                            <div className='d-flex justify-content-end mt-4'>
                                                <button type="submit" disabled={isDisabledButton} className={`width-full ${isDisabledButton ? "disabled-filled-btn-small" : "light-blue-filled-btn-small"}`} style={{ paddingInline: '20px' }}>
                                                    {t('Send')}
                                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M21 12.5H3H21Z" fill="white" />
                                                        <path d="M14 5.5L21 12.5M21 12.5L14 19.5M21 12.5H3" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </form>
                                    </>
                            }

                        </div>
                    </div>
                )}
                <div style={{ marginBottom: '50px' }}>
                    <MoreImagesCard />
                </div>
            </div>
        </div>
    );
}

export default ContactUs;
